import {emptyEditorJSON} from '../../constants';
import {Cell, Row} from '../../plugins/TablePlugin/types';
import {v4 as uuidv4} from 'uuid';

export function createCell(type: 'normal' | 'header'): Cell {
    return {
        colSpan: 1,
        id: uuidv4(),
        json: emptyEditorJSON,
        type,
        width: null
    };
}

export function createRow(): Row {
    return {
        cells: [],
        height: null,
        id: uuidv4()
    };
}
